let DatasetsJson = null;
let loadError = false;

export const setDatasetsJson = (data) => {
  DatasetsJson = data;
  loadError = false;
};

export const getDatasetsJson = () => {
  if (loadError) return null;
  return DatasetsJson;
};

export const setDatasetsError = () => {
  DatasetsJson = null;
  loadError = true;
};

export const hasDatasetsError = () => loadError;
